import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    * {
        box-sizing: border-box;
        outline: none;
    }
    body {
        overflow: auto;
        font-family: "Roboto", "Microsoft JhengHei", "Helvetica";
    }
    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
    ::-webkit-scrollbar-track {
        background: #A9B3BF;
        border-radius: 8px;
        -webkit-box-shadow: initial;
    }
    ::-webkit-scrollbar-thumb {
        border-radius: 8px;
        background: #354252;
    }
    a {
        color: #fb9505;

        :hover{
            color: #fb9505bb;
        }
    }
    .svg-button {
        cursor: pointer;

        :hover path {
            fill: #AAD370;
        }

        :active path {
            fill: #14A0FF;
        }
    }
`;
